"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WishList_module_1 = require("./modules/WishList.module");
const loadWishlistMenuItemModule = () => ({
    hasRouter: false,
    modules: [(0, WishList_module_1.default)()],
});
exports.default = loadWishlistMenuItemModule;
